<template>
  <div class="message_right">
    <transition
      name="fade"
      mode="out-in"
      :duration="{ enter: 200, leave: 300 }"
    >
      <EquipmentMsg ref="equipmentMsgRef" v-if="activeItem == 0" />
      <AlarmMsg ref="alarmMsgRef" v-if="activeItem == 1" />
      <AccountMsg ref="accountMsgRef" v-if="activeItem == 2" />
      <AnnouncementMsg ref="announcementMsgRef" v-if="activeItem == 3" />
    </transition>
  </div>
</template>

<script>
import EquipmentMsg from "./son-tab/equipment-msg.vue";
import AlarmMsg from "./son-tab/alarm-msg.vue";
import AccountMsg from "./son-tab/account-msg.vue";
import AnnouncementMsg from "./son-tab/announcement-msg.vue";
export default {
  components: { EquipmentMsg, AlarmMsg, AccountMsg, AnnouncementMsg },
  inject: ["messageRecordPro"],
  data() {
    return {
      activeItem: 0,
    };
  },
};
</script>

<style scoped lang='less'>
.message_right {
  border: 1px solid #ccc;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>